export default {
    "business": {
        "orderTrack": "运输订单跟踪",
        "updateTo": "修改为",
        "exceptionQty": "异常数",
        "origin": "始发城市",
        "destination": "目的城市",
        "vehicleTeamName": "所属车队",
        "billingItemsName": "计费项",
        "source": "来源",
        "accidentNumber": "异常次数",
        "billNumber": "次数",
        "transIndex": "指数",
        "plateNumber": "车牌号",
        "driverMobile": "司机手机号",
        "certificateNo": "证件号",
        "certificateName": "证件名称",
        "stationType": "站点类型",
        "routeQty": "运单数",
        "locationQty": "地点数量",
        "goodsValue": "声明货值(元)",
        "serviceItemName": "服务项",
        "jobDescription": "职务",
        "counactEmail": "邮箱",
        "createdDt": "创建时间",
        "grade": "级别",
        "carloadQuotation": "是否整车",
        "billingItemName": "费用项",
        "frequency": "频率",
        "sourceName": "数据源",
        "code": "编码",
        "invokeParam": "试算参数",
        "remark": "说明",
        "ruleCode": "规则编码",
        "templateName": "模板名称",
        "motherTemplateName": "报价母板",
        "lightRatio": "泡重比",
        "projectName": "服务产品",
        "editedDt": "修改时间",
        "editorName": "修改人",
        "lifetimeEnd": "失效日期",
        "lifetimeStart": "生效日期",
        "externalContractNo": "外部合同号",
        "partnerName": "伙伴",
        "contractNo": "合同ID",
        "quoteType": "合同类型",
        "creatorName": "创建人",
        "createMode": "创建方式",
        "order": "运输订单",
        "orderNo": "运输订单号",
        "transportNo": "运单号",
        "routeNo": "派车单号",
        "pickUpRouteNo": "提货派车单号",
        "deliverRouteNo": "送货派车单号",
        "originNo": "上游单号",
        "transferNo": "外部单号",
        "goodsBillNo": "随货单号",
        "deliverNo": "中转发货单",
        "plan": "计划",
        "planNo": "计划号",
        "taskNo": "任务号",
        "bill": "账单",
        "billNo": "账单号",
        "status": "状态",
        "itemTypeSearch": "Item Type, Item code, Keyword",
        "partnerOrProjectName": "承运产品/项目",
        "porduct": "承运产品",
        "bizType": "业务类型",
        "paperyReceipt": "纸质回单",
        "receiptQty": "回单数量",
        "light": "轻货",
        "comments": "备注",
        "temperatureControlName": "温控标准",
        "monitorType": "温控类型",
        "volume": "体积(方)",
        "packingQty": "外包装数",
        "isInsurance": "是否保价",
        "tempTypeLimit": "温控范围",
        "weight": "重量(千克)",
        "goodsQty": "货品量",
        "vehicleTypeName": "车型",
        "goodsDescription": "货品类型描述",
        "goodsTypeName": "货品类型",
        "siteName": "站点",
        "contactMobile": "联系人电话",
        "contactName": "联系人",
        "neededLoading": "需装货",
        "provinceCityDistrict": "省/市/区(县)",
        "originProvince": "始发省",
        "originCity": "始发市",
        "originDistrict": "始发区(县)",
        "startCityDistrict": "始发省/市/区(县)",
        "latestDeliveryDt": "最晚发货时间",
        "address": "地址",
        "senderAddress": "发货地址",
        "receiverAddress": "收货地址",
        "pickupComments": "提货说明",
        "neededUnloading": "需卸货",
        "latestReceivedDt": "最晚收货时间",
        "deliveryComments": "送货说明",
        "pickupTotalMarkBool": "货物明细计算",
        "packingGoodsDescription": "货物说明",
        "skuCode": "货品编码",
        "packingUnit": "包装单位",
        "packingVolume": "包装体积(方)",
        "packingWeight": "包装重量(千克)",
        "packageStandard": "包装规格",
        "goodsUnit": "货品单位",
        "packingCloseQty": "包装封闭数",
        "orderType": "单据类型",
        "checkedPersonName": "审核人",
        "createRoute": "创建派车单",
        "senderCity": "发货城市",
        "senderDistrict": "发货区",
        "receiverCity": "收货城市",
        "receiverDistrict": "收货区",
        "originatingSiteName": "发货站点",
        "destinationSiteName": "收货站点",
        "destinationProvince": "目的省",
        "destinationCity": "目的市",
        "destinationDistrict": "目的区/县",
        "temperatureControl": "温控",
        "revokeTransfer": "撤销中转",
        "routeInfo": "派车单信息",
        "routeList": "运单列表",
        "routeDetail": "货物信息",
        "latestBeginTime": "要求发货时间",
        "latestEndTime": "要求收货时间",
        "routeTransferSave": "派车单中转站点设置",
        "noNeededPickupSave": "不提货中转点设置",
        "noNeededDeliverySave": "不送货中转点设置",
        "pickupTransferSaveHandler": "提货段中转点设置",
        "deliveryTransferSaveHandler": "送货段中转点设置",
        "presetLine": "预设线路",
        "orderSource": "运输订单来源",
        "receiverUser": "收货联系人",
        "workAmount": "业务量",
        "rangeReceivedDt": "收货时间",
        "vehicleDetail": "派车信息",
        "planBeginDt": "计划发车时间",
        "planEndDt": "计划完成时间",
        "planDeliveryStartTime": "计划送达时间",
        "planEstimatedTime": "预计用时",
        "planResidenceTime": "预计收货用时",
        "estimatedMileage": "预计里程",
        "planFullLoadRatio": "满载率",
        "planTonKm": "预计吨公里",
        "routeName": "线路名称",
        "locationGPS": "地址定位",
        "workType": "作业类型",
        "earliestReceivedDt": "要求收货时间窗",
        "autoLine": "自动规划",
        "fixedLine": "固定线路",
        "destinationSite": "目的站点",
        "originatingSite": "始发站点",
        "origindistrict": "始发区/县",
        "transportOrderDetail": "运单信息",
        "inBatchesLabel": "允许分批",
        "orderBillingCost": "预计费用",
        "transportationOrderType": "运输订单类型",
        "transportDialogTitle": "运输信息一览图",
        "capacityDriver": "司机姓名",
        "fileName": "文件名",
        "vehicleTemperature": "车温",
        "routeCarloadQuotation": "整车",
        "prebookPickupDt": "预约提货时间",
        "dispatcherName": "调度人",
        "transportStatus": "运单状态",
        "transportExPickupScanDt": "提货扫描时间",
        "equipmentNo": "跟踪器号",
        "pickupRemarks": "提货备注",
        "actualPackingQty": "实提包装数",
        "actualVolume": "实提体积(方)",
        "actualGoodsQty": "实提货品量",
        "actualWeight": "实提重量(千克)",
        "pickupEndDt": "提货完成时间",
        "pickupBeginDt": "提货开始时间",
        "pickupArrivalDt": "提货到达时间",
        "originalWorkAmount": "作业记录量",
        "workRecord": "作业记录",
        "transferType": "中转类型",
        "transferCenterNo": "中转单号",
        "transferSiteName": "中转站点",
        "shipperShortName": "货主简称",
        "receivedGoodsTemperature": "收货货温℃",
        "pickupedGoodsTemperature": "提货货温℃",
        "toVoid": "作废",
        "reCcollectGoods": "重收",
        "transferBill": "中转单",
        "deliveryDt": "发货时间",
        "affixedCodeType": "标签类型",
        "deliveryPackingQty": "实发包装数",
        "receivablePackingQty": "应收包装数",
        "receiptPackingQty": "实收包装数",
        "receivableWeight": "应收重量(千克)",
        "receivableVolume": "应收体积(方)",
        "receiptWeight": "实收重量(千克)",
        "receiptVolume": "实收体积(方)",
        "deliverPackingQty": "应发包装数",
        "damagedPackingQty": "损坏包装数",
        "occurrenceTime": "生成时间",
        "exceptionNo": "异常号",
        "exceptionType": "异常类型",
        "exceptionDescription": "异常信息",
        "transportExDeliveryEndDt": "送货完成时间",
        "executeStatus": "执行状态",
        "actualMileage": "实际里程",
        "transportExDeliveryScanDt": "送货扫描时间",
        "totalGoodsQty": "总货品量",
        "totalPackingQty": "总包装数",
        "missedPackingQty": "丢失包装数",
        "rejectedPackingQty": "拒收包装数",
        "missedGoodsQty": "丢失货品量",
        "damagedGoodsQty": "损坏货品量",
        "rejectedGoodsQty": "拒收货品量",
        "receiptGoodsQty": "实收货品量",
        "deliveryBeginDt": "收货开始时间",
        "deliveryArrivalDt": "送货到达时间",
        "prebookDeliveryDt": "预约送货时间",
        "vehicleTypeNameOfWork": "实际车型",
        "vehicleArrivalDt": "车辆到站时间",
        "dispatchingDt": "调度时间",
        "curTime": "发生时间",
        "handleTime": "处理时间",
        "confirmTime": "确认时间",
        "confirmPerson": "确认人",
        "personLiable": "责任人",
        "rejectedTreatmentMethod": "拒收处理方式",
        "signPersonDt": "签收时间",
        "taskInfo": "任务信息",
        "requiredReceipt": "需要纸质回单",
        "mobile": "手机",
        "emailSubject": "邮件主题",
        "neededPickup": "需提货",
        "neededDelivery": "需送货",
        "vehicleTypeAndNumber": "车型*数量",
        "batchCode": "批次",
        "planRouterTips": "该点运单在当前路单上，请选择其他路单",
        "reportDataErrTips": "报表信息有错误，请先完善报表信息",
        "gpsDataLoadingTips": "跟踪数据正在刷新，请稍后重新查看",
        "orderCreatorName": "订单创建人",
        "noteTakerName": "记录人",
        "trailerType": "Trailer Type",
        "trailerPlateNumber": "Trailer Plate Number",
        "trailerProvincialSign": "Trailer Provincial Sign",
    },
    "commonTips": {
        "billingTipsValidata": "请输入2至100字以内的原因说明",
        "billingTipsContent": "原因说明(必填，限一百字)",
        "attachmentParameterErrorTips": "附件参数错误，请关闭浮页重试！",
        "vehicleTypeNameTips": "请输入车型",
        "timeRangeTips": "选择时间范围",
        "enterInfoTips": "请填写已添加信息内容后方可添加下一条",
        "creatorNameTips": "请输入创建人",
        "tempRangeTips": "温控范围最小值必须小于最大值！",
        "businessPartnerTips": "请输入业务伙伴",
        "refuseTips": "确定要拒绝吗?",
        "mustExcelFileTips": "必须是excel文件，建议先下载模版然后填写!",
        "inputRequired": "必填",
        "selectRequired": "必选",
        "partnerNameTips": "请选择伙伴",
        "ruleCodeTips": "请输入规则编码(最长32字)",
        "ruleTips": "请输入规则名称(最长32字)",
        "max200": "(最大200字)",
        "max500": "(最大500字)",
        "importInformationTips": "导入信息提示",
        "copyAndPasteTips": "复制成功，现在可以粘贴到Excel或者文本编辑器方便查阅",
        "uploadingTips": "拼命上传中",
        "fileSupportTypeTips": "选择文件（只支持xls或xlsx）",
        "confirmOperation": "是否确认操作?",
        "areYouSureToDelete": "是否确认删除",
        "pleaseSelectProjectName": "请选择项目",
        "max100": "(最大100字)",
        "pleaseInputRemark": "请输入说明",
        "pleaseSelectDate": "请选择日期",
        "multipleTips": "可选择多个",
        "cancelRouteTransferTips": "撤销中转是否继续",
        "workAmountTips": "请输入业务量",
        "contactNameTips": "请输入联系人",
        "contactMobileTips": "请输入联系人电话(必填)",
        "pleaseSelectSiteName": "请选择站点",
        "pleaseSelectVehicleType": "请选择车型",
        "cargoOwnerTips": "请输入货主",
        "revokeSucceededTips": "撤销审核成功!",
        "pushTips": "上游TMS账号推送",
        "pleaseInputRouteNo": "请输入派车单号",
        "sendSuccess": "发送成功",
        "routeNoIdNotNullTips": "派车单ID不能为空",
        "waybillNoSaveSucceessTips": "运单顺序已保存!",
        "pleaseInputCarrier": "请输入承运商",
        "pleaseInputSubcontractor": "请输入承运商",
        "receiveDatasTips": "没有发货单",
        "removeRouteTips": "确定移除该标点下的所有运单吗?",
        "routerSuccessTips": "派车单确认成功",
        "senderAddressStationIdTips": "请输入发货地址或者选择站点",
        "senderCityTips": "请输入发货城市",
        "pleaseInputTransportNo": "请输入运单号",
        "capacityTypeCodeTips": "请输入车型！",
        "capacityDriverMobileTips": "请输入司机电话！",
        "capacityPlateNoTips": "请输入车牌号！",
        "capacityDriverTips": "请输入司机！",
        "capacityIdentificationTips": "请输入司机证件！",
        "transferBillTips": "请输入中转单号！",
        "pleaseSelectTransferBill": "请选择中转单！",
        "pleaseConfirmGoods": "请确认货物已经放回原存放位置！",
        "waybillNoNotNullTips": "运单号不能为空!",
        "expressNoTips": "快递单号格式不正确!",
        "isConfirmReceipt": "是否确认电子回单？",
        "isConfirmPOD":"您要验证 EPOD 和/或 POD 吗?",
        "dataCorrectionWarn":'请检查并确认最终工作的信息 Data Correction',
        "reminder": "警告",
        "isConfirmPaperReceipt": "是否确认纸质回单？",
        "isConfirmReceiptTips": "是否确认回单？",
        "backConfirmDt": "请选择收到回单的时间",
        "mobileNumberFormatError": "手机格式不正确",
        "mobileNumberExist": "手机号已存在",
        "emailFormatError": "邮箱格式不正确",
        "emailExist": "邮箱地址已存在",
        "mobileTotalLengthError": "录入的手机号总长度不能超过500",
        "isConfirmReanalyze": "是否对此账单进行重新确认操作？",
        "transportProductError": "托运产品有误,不能同步!",
        "ownCarOrIndividualDriverNoTransportProduct": "自有车或个体司机无托运产品/项目信息！",
        "reanalyzeBillSuccess": "重算账单成功!",
        "insuranceValueMustGreaterThanZero": "保价为'Y'时，声明货值必须大于0！",
        "pleaseSelectOneMessage": "请选择至少一条消息!",
        "cancelTransitSuccess": "撤销中转成功！",
        "transitSuccess": "派车单中转成功！",
        "isAddSamePickupAddressWaybill": "是否将提送货地相同的运单一起加入派车单？",
        "isFixedRoute": "此操作将把当前筛选条件下的数据固定线路, 是否继续?",
        "pleaseSelectTransitBill": "请选择派车单（只允许选择一个派车单）",
        "transitBillStatusMustNotClosedOrFinished": "派车单状态必须是非关闭，非完成状态。",
        "waybillAppendSuccess": "运单追加成功",
        "replanOnlyNewOrUndispatchTransitBill": "重新计划只能是新建或者未调度状态派车单！",
        "isContinueReplan": "是否继续重新计划操作？",
        "emailAddressLengthMustLessThan500": "录入的邮箱地址总长度不能超过500",
        "pleaseSelectGroupFieldOrStatisticField": "请先选择分组字段或者统计字段！",
        "pleaseSelectField": "请选择字段！",
        "pleaseSelectReportType": "请选择报表类型！",
        "pleaseSelectTimeRange": "请选择时间范围！",
        "reportIsGenerating": "报表正在生成中！",
        "dateRangeMustLessThan61Days": "日期范围不能超过61天！",
        "uploadImageOnlyJpgPngJpegBmp": "上传图片只能是 jpg,png,jpeg,bmp格式!",
        "uploadImageSizeMustLessThan2Mb": "上传图片大小不能超过 2MB!",
        "noFileToDownload": "没有附件,不用打包下载!",
        "trackingDataIsRefreshing": "跟踪数据正在刷新，请稍后重新查看！"
    },
    "error": {
        "validatorError": "你有输入错误的地方，请改正！",
        "errorMsg": "错误信息",
        "errorMsgData": "缺少必要数据,请刷新页面后重试!",
        "dataLoadError": "数据加载异常"
    },
    "public": {
        'keywordCannotBeEmpty': '关键字不能为空',
        'itemTypeCannotBeEmpty': '货品类型不能为空',
        "typeCodeCannotBeEmpty": "类型编码不能为空",
        "download": "下载",
        "name": "姓名",
        "have": "自有",
        "loading": "加载中",
        "distribution": "城配",
        "confirmed": "确认",
        "endDate": "结束日期",
        "startDate": "开始日期",
        "edit": "编辑",
        "vehicleInfo": "车辆信息",
        "saving": "保存中...",
        "serviceInfo": "服务信息",
        "qicq": "QQ",
        "wechat": "微信",
        "male": "男",
        "female": "女",
        "userGender": "性别",
        "remove": "移除",
        "validityRange": "有效期范围",
        "provincCityDistrict": "省市区(县)",
        "siteInfo": "站点信息",
        "businessPartner": "业务伙伴",
        "suspend": "暂停",
        "attribute": "属性",
        "operationLog": "操作记录",
        "personnelInfo": "人员信息",
        "carrier": "承运商",
        "partnerAddName": "伙伴名称",
        "baseInfo": "基本信息",
        "refuse": "拒绝",
        "agree": "接受",
        "postalAddress": "通讯地址",
        "offline": "离线",
        "online": "在线",
        "shortName": "简称",
        "lineNo": "行号",
        "message": "信息",
        "importSuccess": "导入成功",
        "no": "否",
        "yes": "是",
        "dayText": "日",
        "sequencing": "调序",
        "shareRule": "分摊规则",
        "disableSuccess": "禁用成功",
        "enableSuccess": "启用成功",
        "enableTips": "确定要启用吗?",
        "uploadFail": "上传失败",
        "uploadSuccess": "上传成功",
        "submitTips": "确定提交吗?",
        "submitSuccess": "提交成功",
        "copyAll": "复制所有信息",
        "clickUpload": "点击上传",
        "uploadTemplate": "上传模板",
        "pass": "通过",
        "noPass": "不通过",
        "revoke": "撤销",
        "deConfirm": "反确认",
        "submit": "提交",
        "deleteSuccess": "删除成功",
        "saveSuccess": "保存成功",
        "recalculationSuccess": "重算成功",
        "cancelled": "已取消",
        "editSucceeded": "修改成功",
        "relationFile": "相关附件",
        "contractInfo": "合同信息",
        "add": "创建",
        "new": "新建",
        "rename": "改名",
        "modify": "修改",
        "delete": "删除",
        "confirm": "确定",
        "cancel": "取消",
        "enable": "启用",
        "disable": "禁用",
        "configure": "配置",
        "inputRequired": "(必填)",
        "selectRequired": "(必选)",
        "operation": "操作",
        "deleteTips": "确定要删除吗?",
        "deleteItemType": "Are you sure you want to remove Item Type?",
        "disableTips": "确定要禁用吗?",
        "tips": "提示",
        "operationSuccessful": "操作成功",
        "search": "查询",
        "save": "保存",
        "preview": "预览",
        "pleaseSelect": "请选择",
        "pleaseEnter": "请输入",
        "pleaseNotOnlyOne": "请至少勾选一条数据！",
        "moreShow": "更多…",
        "moreHide": "收起",
        "maxValue": "最大值",
        "minValue": "最小值",
        "start": "开始",
        "end": "结束",
        "noData": "暂无数据",
        "setColumn": "设置列",
        "reset": "重置",
        "import": "导入",
        "export": "导出",
        "exporting": "导出中...",
        "downloadTemplate": "下载模板",
        "back": "返回",
        "valueAddedServices": "增值服务",
        "notice": "通知",
        "remind": "提醒",
        "earlyWarning": "预警",
        "userName": "用户名",
        "trunkLine": "干线",
        "dispatch": "调度",
        "planDispatch": "计划调度",
        "pickupGoods": "提货",
        "noPickupGoods": "未提货",
        "deliverGoods": "送货",
        "noDeliverGoods": "未送达",
        "abnormal": "异常",
        "receipt": "回单",
        "receiptShipper": "货主回单",
        "shipper": "货主",
        "receiptDriver": "司机回单",
        "driver": "司机",
        "news": "消息",
        "read": "已读",
        "msgInfo": "消息内容",
        "hour": "时",
        "minute": "分",
        "second": "秒",
        "log": "日志",
        "top": "置顶",
        "bottom": "置底",
        "reportName": "报表名称",
        "date": "日期",
        "time": "时间",
        "number": "数量",
        "title": "标题",
        "emailAddress": "邮件地址",
        "empty": "空",
        "line": "线路",
        "lng": "经度",
        "lat": "纬度",
        "startTime": "开始时间",
        "endTime": "结束时间",
        "pleaseNotOnlyOneR": "请选择一条派车单记录!",
        "pleaseNotOnlyOneT": "请至少选择一条运单记录!",
        "warning": "警告",
        "unit": "单位",
        "allSelect": "全选",
        "shippingInfo": "送货说明",
        "destinationInfo": "收货地信息",
        "shipToInfo": "发货地信息",
        "cargoInfo": "货物信息",
        "individual": "个",
        "enclosure": "附件",
        "askEndTime": "要求结束时间",
        "askStartTime": "要求开始时间",
        "routeAdd": "追加",
        "pushNew": "添加",
        "executing": "执行中...",
        "destinationAddress": "目的地址",
        "originAddress": "始发地址",
        "planTransportTime": "计划运输时间",
        "productsAnditems": "托运产品/项目",
        "downloadDocument": "下载单据",
        "shortMessage": "短信",
        "receivingPlace": "收货地点",
        "deliverGoodsPlace": "发货地点",
        "saveOrder": "保存顺序",
        "trackEquipment": "跟踪器",
        "abnormalTemperature": "温度异常",
        "noEquipment": "无设备",
        "fulload": "满载",
        "pushMore": "追单",
        "receiptWay": "回单方式",
        "pickUpInfo": "提货信息",
        "transportProcessPreview": "运输过程一览",
        "sender": "发货人",
        "operationError": "操作失败",
        "print": "打印",
        "mapTrack": "地图跟踪",
        "totalWeight": "总重量(千克)",
        "totalVolume": "总体积(方)",
        "transportVehicleInfo": "运输车辆信息",
        "sendInfo": "送货信息",
        "transportNoSearch": "运单号查询",
        "routeNoTrack": "派车单跟踪",
        "overTemperature": "超温",
        "billingDetail": "计费信息",
        "close": "关闭",
        "closedTips": "确定要关闭吗?",
        "receiverName": "收货人",
        "oAndtNo": "订单号",
        "transportationTrack": "订单号",
        "imageOrFile": "照片/附件",
        "receiptLable": "收到",
        "chooseDateTime": "选择日期时间",
        "finishTime": "完成时间",
        "send": "发送",
        "messageContent": "短信内容",
        "optionMode": "交接类型",
        "type": "类型",
        "createSuccess": "创建成功",
        "noset": "未分配",
        "before": "前",
        "after": "后",
        "continue": "您是否继续",
        "route": "派车单",
        "transport": "运单",
        "systemMsg": "系统消息",
        "selectPageStyle": "请选择纸质单样式",
        "accountRoleError": "该账号无权访问,请重新登录",
        "deliveryTypeName": "送货车型",
        "senderAddressNum": "始发地点数",
        "receiverAddressNum": "目的地点数",
        "need": "需要",
        "notNeed": "不需要",
        "checkAccountDesc": "对账说明",
        "autoSwitchBillDate": "此单据业务日期将不在此账单日期范围内，是否需要自动切换到对应账期的账单中？",
        "selectOrgNode": "请选中组织部门节点",
        "sureSave": "确定要保存吗?",
        "selectType": "请选择类型",
        "notFixedLine": "不在固定线路",
        "addToFixedLine": "是否需要将这些站点加入此固定线路中？",
        "electronic_receipt_attachment": "电子回单附件",
        "sureAutoAdd": "此操作将把当前筛选条件下的数据进行自动追加, 是否继续?",
        "noMatchRoute": "没有匹配到对应派车单",
        "removeTransportSuccess": "移除运单成功",
        "sureAutoAddRoute": "此操作将把当前筛选条件下的数据进行线路预设, 是否继续?",
        "selected": "选中",
        "mapTips1": "运单用线表示：有色为“已发运”的，灰色实线为“已调度”的，灰色虚线为“未调度”的，圆形表示始发和目的地，四边形表示",
        "mapTips2": "中转地，灰色图形：没有运单到达的地点，有色图形：有运单到达的地点，空心图形：没有中转单，实心图形：有中转单",
        "importAndCheck": "导入&对账",
        "pleaseSelectCarType": "请选择汽车车型！",
        "pleaseInputCarNumber": "请输入汽车数量！",
        "productServiceRequired": "产品/项目必选服务",
        "waybillNotShipped": "运单还未发货！",
        "pleaseInputCurrentPassword": "请输入当前密码。",
        "pleaseInputNewPassword": "请输入新密码。",
        "pleaseInputConfirmPassword": "请输入确认密码。",
        "newAndOldPasswordCannotBeSame": "新旧密码不能相同。",
        "twoPasswordNotSame": "两次输入密码不一致。",
        "noFeeIdOrBillStatus": "未获取到计费ID或账单状态。",
        "cannotRefreshExtraCapacityAttribute": "无法同步刷新额外的运力属性。",
        "cannotModify": "不能修改！",
        "productServiceMustBeService": "产品/项目必须服务，不能修改。",
        "isLoadNextBatchData": "已滚动到最底是否加载下一批数据？",
        "isLoadPreviousBatchData": "已滚动到最顶是否加载上一批数据？",
        "reanalyzeSubmitSuccess": "重新分析提交成功！",
        "completeCheckSuccess": "完成对账成功！",
        "addPointFee": "加点费",
        "pickupFee": "提货费",
        "deliveryFee": "送货费",
        "loadingFee": "装货费",
        "unloadingFee": "卸货费",
        "emptyFee": "放空费",
        "totalFee": "总终费",
        "otherFee": "其他费用",
        "waitRecive": "待收货",
        "transitAddress": "中转地",
        "static": "静止",
        "basicDataLoadFail": "基础数据加载失败，请尝试按F5刷新页面后重试。",
        "dan": "单",
        "car": "辆",
        "homePage": "首页",
        "switchChangeDrag": "点击切换显示，拖拽调序",
        "receiptDemandDt": "要求回单日期",
        "cancelTransitTips": "是否撤销分段中转?",
        "cancelBreakTips": "是否撤销拆分?",
        "transportbreakTips": "确定终止运输?",
        "adjustBillingCost": "调整计费",
        "workBillingCost": "作业计费",
        "orderBillingCost": "下单计费",
        "itemType": "项目类型",
        "originatingSiteType": "原始站点类型",
        "destinationSiteType": "目标站点类型",
        "carModel": "汽车模型",
        "temperatureControl": "温度控制",
        "weightKg ": "weight (kg)",
        "waybillNumber": "waybill number",
        "numberOfSites": "number of sites",
        "unit": "unit"
    },
    "unit": {
        "km": "千米",
        "kg": "千克",
        "min": "分钟",
        "square": "方",
        "box": "box",
        "gram": "g",
        "jin": "jin",
        "gongjin": "kg",
        "ton": "ton",
        "gongli": "KM",
        "js": "piece",
        "zhan": "site "
    },
    "weekObj": {
        "monday": "monday",
        "tuesday": "tuesday",
        "wednesday": "wednesday",
        "thursday": "thursday",
        "friday": "friday",
        "saturday": "saturday",
        "sunday": "sunday",
        "week": "week"
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN.js